import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class HashtagSelector extends BaseOption {
  static label = "Hashtag";
  static userInterfaceComponent = () => {
    return { component: inspectorTools.SIMPLE_INPUT };
  };

  static defaultValue = "";
}
